/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGroceryIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-grocery"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 20.75Q2.75 20.75 1.98 19.98Q1.2 19.2 1.2 18.1L1.2 10.3Q1.2 10.1 1.24 9.89Q1.27 9.68 1.35 9.47L3.23 5.08L3.23 5.08Q2.83 5 2.54 4.67Q2.25 4.35 2.25 3.9L2.25 2.4Q2.25 1.9 2.6 1.55Q2.95 1.2 3.45 1.2L11.3 1.2Q11.8 1.2 12.15 1.55Q12.5 1.9 12.5 2.4L12.5 3.9Q12.5 4.35 12.21 4.67Q11.93 5 11.53 5.08L11.53 5.08L12.82 7.9Q10.32 9.03 8.81 11.11Q7.3 13.2 7.3 16.05Q7.3 17.25 7.65 18.5Q8 19.75 8.68 20.75ZM16.05 22.8Q13.25 22.8 11.28 20.82Q9.3 18.85 9.3 16.05Q9.3 13.22 11.28 11.26Q13.25 9.3 16.05 9.3Q18.88 9.3 20.84 11.26Q22.8 13.22 22.8 16.05Q22.8 18.85 20.84 20.82Q18.88 22.8 16.05 22.8ZM16.05 8.55Q14.7 8.55 13.88 7.72Q13.05 6.9 13.05 5.55Q13.05 4.2 13.88 3.38Q14.7 2.55 16.05 2.55L16.05 8.55Q16.05 7.2 16.88 6.38Q17.7 5.55 19.05 5.55Q20.4 5.55 21.23 6.38Q22.05 7.2 22.05 8.55Z" fill={color} />
    </svg>
  );
}
